import { getShippingMethods } from '../shipping/shippingModule';
import { deliveryStepPreConditions, deliveryStepPostConditions } from './deliveryStepSelectors';
import { giftCardFieldNames } from '../item/newItemForm';



const deliveryStepConfig = {
    component: () => import('./DeliveryStep'),
    flow: 'buy',
    onExit: (dispatch, ownProps, values) => {
        const { isPlastic } = ownProps;

        if (isPlastic) {
            const mergedValues = values.merge({
                hasAccessory: !!values.get(giftCardFieldNames.ITEM_ACCESSORY, false)
            });
            dispatch(getShippingMethods(mergedValues));
        }
    },
    preConditions: deliveryStepPreConditions,
    postConditions: deliveryStepPostConditions
};

export default deliveryStepConfig;
